import { InvManagementMethod } from './itemGroup';

export const IssueMethod = {
  MANUAL: 'MANUAL',
  BACKFLUSH: 'BACKFLUSH',
};

export const IssueMethodList = [
  { label: 'Kézi', value: IssueMethod.MANUAL },
  { label: 'Automata', value: IssueMethod.BACKFLUSH },
];

export const isAutomaticIssueMethodAllowed = (item) => {
  return (item?.invManagementMethod ?? InvManagementMethod.NONE) === InvManagementMethod.NONE;
};

export const ProductionIssueDirection = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING',
};
